import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card bg-transparent" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header p-0 border-0" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, " Historial de participación ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_Drawer1 = _resolveComponent("Drawer1")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", {
        class: _normalizeClass(["card-body", _ctx.listHistory.length>0 ? 'bg-transparent p-0' : 'bg-white'])
      }, [
        (_ctx.listHistory.length>0)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.listHistory, (item, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: 'lst-h-' + index
              }, [
                _createVNode(_component_el_badge, {
                  value: item.events.length,
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      "data-bs-toggle": "collapse",
                      "data-bs-target": `#periodo-${index}`,
                      "aria-expanded": "false",
                      "aria-controls": `periodo-${index}`
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Periodo " + _toDisplayString(item.periodo), 1)
                      ]),
                      _: 2
                    }, 1032, ["data-bs-target", "aria-controls"])
                  ]),
                  _: 2
                }, 1032, ["value"]),
                _createVNode(_component_el_table, {
                  data: item.events,
                  border: "",
                  style: {"width":"100%"},
                  class: "mb-6",
                  "table-layout": 'auto'
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      prop: "idacreditation",
                      label: "ID",
                      width: "80",
                      align: "center"
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "event_name",
                      label: "EVENTO",
                      width: "300"
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "sport_name",
                      label: "DEPORTE",
                      width: "150"
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "function_name",
                      label: "FUNCIÓN",
                      width: "150"
                    }),
                    _createVNode(_component_el_table_column, { label: "ESTADO" }, {
                      default: _withCtx((scope) => [
                        _createElementVNode("span", {
                          class: _normalizeClass(`badge badge-${scope.row.check_class}`)
                        }, _toDisplayString(scope.row.check_name), 3)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      fixed: "right",
                      label: "OPCION",
                      align: "center",
                      width: "100"
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_button, {
                          size: "small",
                          onClick: ($event: any) => (_ctx.handleRowClick(scope.row))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Detalles")
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1032, ["data"])
              ], 64))
            }), 128))
          : (_openBlock(), _createBlock(_component_el_empty, {
              key: 1,
              description: "No hay información para mostrar"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "success",
                  onClick: _ctx.getHistory
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Volver a intentar")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            }))
      ], 2)
    ])), [
      [_directive_loading, _ctx.loader]
    ]),
    _createVNode(_component_Drawer1, { row: _ctx.selectedRow }, null, 8, ["row"])
  ], 64))
}